<<!--产品服务-->
<template>
  <div class="mt-20 list-cont">
    <div class="s-list mb-15 inline-b">
      <i class="el-icon-s-platform fz-32 c-c0c icons fl" :class="[user_info.app_key?'c-9da':'']"></i>
      <div class="fl list-r">
        <div class="line-18 mt-16 mb-15">
          <span class="fz-18 c-333">开放平台</span>
          <i class="el-icon-success ml-10 c-66c fz-16" v-if="user_info.app_key"></i>
        </div>
        <div class="fz-14 c-999 line-20">多样化的API数据接口，共享优质数据，满足不同用户群体需求。高佣转链工具接口，轻松实现最大化流量变现。</div>
        <div>
          <el-button
            type="primary"
            plain
            class="mt-15 w-80"
            v-if="!user_info.app_key"
            @click="goSomepage(1)"
          >开通</el-button>
          <el-button
            type="primary"
            plain
            class="mt-15 w-100"
            v-if="user_info.app_key"
            @click="goSomepage(2)"
          >调用API接口</el-button>
        </div>
      </div>
    </div>

    <!-- <div class="s-list mb-15 inline-b ml-15">
      <i class="el-icon-s-shop fz-32 c-c0c c-9da icons fl"></i>
      <div class="fl list-r">
        <div class="fz-18 c-333 line-18 mt-16 mb-15">
          <span class="fz-18 c-333">商品总库</span>
          <i class="el-icon-success ml-10 c-66c fz-16"></i>
        </div>
        <div class="fz-14 c-999 line-20">专业编审团队人工甄选优质内容，每日万款商品实时更新，百万DAU数据校验。大数据帮你选品，专业小编帮你打造优质内容。</div>
        <div>
          <el-button type="primary" plain class="mt-15 w-100" @click="goSomepage(4)">选择商品</el-button>
        </div>
      </div>
    </div> -->

    <div>
      <!-- <div class="s-list mb-15 inline-b">
        <i class="el-icon-menu fz-32 c-c0c icons fl" :class="[user_info.status==2?'c-9da':'']"></i>
        <div class="fl list-r">
          <div class="fz-18 c-333 line-18 mt-16 mb-15">
            <span class="商品总库">内容合作</span>
            <i class="el-icon-success ml-10 c-66c fz-16" v-if="user_info.status==2"></i>
          </div>
          <div class="fz-14 c-999 line-20">多渠道流量分发，提报单品触达百万用户，星罗好货助你轻松跑单出爆款。</div>
          <div>
            <el-button
              type="primary"
              plain
              class="mt-15 w-80"
              v-if="user_info.status==0||user_info.status==1"
              @click="goSomepage(5)"
            >开通</el-button>
            <el-button
              type="primary"
              plain
              class="mt-15 w-100"
              v-if="user_info.status==2"
              @click="goSomepage(6)"
            >提报商品</el-button>
          </div>
        </div>
      </div> -->
      <!-- 大人带货 -->
      <!-- <div class="s-list mb-15 inline-b ml-15">
        <i class="el-icon-s-goods fz-32 c-c0c icons fl" :class="[user_info.status==2?'c-9da':'']"></i>
        <div class="fl list-r">
          <div class="fz-18 c-333 line-18 mt-16 mb-15">
            <span class="">达人带货</span>
            <i class="el-icon-success ml-10 c-66c fz-16" v-if="user_info.status==2"></i>
          </div>
          <div class="fz-14 c-999 line-20">小编精选爆款单品，短视频/直播达人免费获得带货样品，高品质带货视频模板，快速选品，高效变现。</div>
          <div>
            <el-button
              type="primary"
              plain
              class="mt-15 w-80"
              @click="goSomepage(7)"
              v-if='user_info.video_channels_status==0'
            >开通</el-button>
            <el-button
              type="primary"
              plain
              class="mt-15 w-100"
              @click="goSomepage(8)"
               v-if='user_info.video_channels_status==1'
            >选择商品</el-button>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import "./tool.css";
export default {
  name: "server",
  data() {
    return {
      api: {
        getUserInfo: "/home/getUserInfo" //检测apikey
      },
      user_info: {} //信息
    };
  },
  components: {},
  created() {},
  mounted() {
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      let _this = this;
      let data = {};
      this.$http({
        method: "GET",
        url: _this.api.getUserInfo,
        params: data
      }).then(res => {
        if (res.code == 1) {
          _this.user_info = res.data;
        } else {
          _this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
    goSomepage(num) {
      // 1 api接口页
      // 2 开放平台页
      // 3 pid设置页
      // 4 商品总库
      // 5 未通过进入待审核页面
      // 6 提报单品
      // 7 kol认证
      // 8 商品总库达人带货
      if (num == 1) {
        window.open("https://xl.linkstars.com/admin/#/my/api");
      } else if (num == 2) {
        window.open("https://openapi.linkstars.com/doc/home/");
      } else if (num == 3) {
        window.open("https://xl.linkstars.com/admin/#/my/mypid");
      } else if (num == 4) {
        window.open("https://xl.linkstars.com/list/list");
      } else if (num == 5) {
        window.open("https://xl.linkstars.com/admin/#/auth");
      } else if (num == 6) {
        if (this.user_info.type == 2) {
          window.open("https://xl.linkstars.com/admin/#/mation/overview");
        } else {
          window.open("https://xl.linkstars.com/admin/#/goods/subsomeone");
        }
      }else if(num==7){
          window.open("https://xl.linkstars.com/admin/#/my/heads?type=2");
      }else if(num==8){
         window.open("https://xl.linkstars.com/list/kol?type=kol");
      }
    }
  }
};
</script>
<style  scoped>
.list-cont {
  min-width: 980px;
}
.s-list {
  width: 472px;
  height: 148px;
  border: 1px solid #e8eaf2;
}
.icons {
  margin: 14px 29px 0 24px;
}
.list-r {
  width: 377px;
}
</style>